import React from 'react';

const SilhouetteGroup: React.FC = () => {
  return (
    <div className="flex justify-center items-end gap-4 mb-12 h-30">
      <img src="/silhuette1.png" alt="Person silhouette" className="h-24 w-auto object-contain brightness-0" />
      <img src="/silhuette2.png" alt="Person silhouette" className="h-20 w-auto object-contain brightness-0" />
      <img src="/silhuette3.png" alt="Person silhouette" className="h-24 w-auto object-contain brightness-0" />
      <img src="/silhuette4.png" alt="Person silhouette" className="h-20 w-auto object-contain brightness-0" />
    </div>
  );
};

export default SilhouetteGroup;